import LiquidWaste from '../components/LiquidWaste';

function LiquidWastePage() {
  return <LiquidWaste />;
}

export default LiquidWastePage;
